import { WatchlistsState } from './slice'

export const selectWatchlists = (state: { watchlists: WatchlistsState }) => state.watchlists.watchlists
export const selectOrder = (state: { watchlists: WatchlistsState }) => state.watchlists.order
export const selectSelectedTab = (state: { watchlists: WatchlistsState }) => state.watchlists.selectedTab
export const selectActiveWatchlistId = (state: { watchlists: WatchlistsState }) => state.watchlists.activeWatchlistId
export const selectFavouriteMarketIds = (state: { watchlists: WatchlistsState }) => state.watchlists.favouriteMarketIds
